module.exports = __webpack_public_path__ + "static/media/microwave.a8dab75c.svg";